<template>
    <section class="wib-customer-service">
        <div class="wib-customer-service__content">
            <img :src="customerServiceData.mini_logo_url " alt="">
            <h3 class="wib-customer-service__text" v-html="customerServiceData.body" />
        </div>
    </section>
</template>

<script>
export default {
    name: "CustomerService",
    props: {
        customerServiceData: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@s/_asset-mixers.scss';

.wib-customer-service {
    padding: 50px 0;
    background-color: #2C0042;
    color: $white;
    text-align: center;

    @media (max-width: 991px) {
        padding: 40px 15px;
    }

    &__content {
        max-width: 775px;
        margin: 0 auto;
    }
}
</style>

<style lang="scss">
.wib-customer-service__text {
    font-size: 36px;
    line-height: 43px;
}
</style>